import { StudentFormEntry } from '../types';

const isValidStudent = (x: StudentFormEntry) =>
  x.firstName && x.lastName && x.secretCode && x.gradeLevel;

export default isValidStudent;
